import { useEffect, useState } from "react";
import { PanelGenerico } from "../../../components/generic/PanelGenerico";
import { TagDefault, TagInfo } from "../../../components/indicadores/Tags";
import COLORES from "../../../utils/theme/colores";
import ListaVerificacionService from "../../../services/listaVerificacionService";

interface FotosCheckListProps {
  ulrFostos: string[];
  isOpen: boolean;
  dismiss: (
    ev?: React.SyntheticEvent<HTMLElement, Event> | KeyboardEvent | undefined
  ) => void;
}

//#region
// eslint-disable-next-line jsx-a11y/alt-text
const Foto = ({ ruta }) => (
  <img
    src={`${ruta}`}
    style={{
      maxWidth: 400,
      maxHeight: 500,
      margin: 20,
      padding: 10,
      border: `solid 1px ${COLORES.Bases.primary}`,
      borderRadius: 10,
    }}
  />
);
const FotosCheckList: React.FunctionComponent<FotosCheckListProps> = (prop) => {
  const [listImg64, setListImg64] = useState<string[]>([]);

  const listaImg = () => {
    const newList: IListLink = { listUrlBase: [] };
    if (prop.ulrFostos.length !== 0) {
      newList.listUrlBase = prop.ulrFostos;
    }
    ListaVerificacionService.listarImgMantenimiento(newList)
      .then((res) => {
        // console.log(res.data)
        setListImg64(res.data);
      })
      .catch((e) => {
        alert(e);
      });
  };

  useEffect(() => {
    if (prop.isOpen) {
      listaImg();
    }
  }, [prop.isOpen]);

  return (
    <>
      <PanelGenerico
        isOpen={prop.isOpen}
        onDismiss={prop.dismiss}
        enabledFooter={true}>
        {/* {prop.ulrFostos.map((url, i) => {
          return (
            <div key={i}>
              <TagDefault bodyMenssaje={`Foto : ${i + 1}`}></TagDefault>
              {/* {url} * /}
              <Foto ruta={url}></Foto>
            </div>
          );
        })} */}
        {listImg64.map((base64Data, i) => {
          return (
            <div key={i}>
              <TagDefault bodyMenssaje={`Fotoss : ${i + 1}`}></TagDefault>
              {/* {url} */}
              {/* <img
                src={`data:image/${"png"};base64,${base64Data}`}
                alt="Image"
              /> */}
              {/* <Foto ruta={`data:image/${"png"};base64,${base64Data}`}></Foto> */}

              <Foto ruta={base64Data}></Foto>
            </div>
          );
        })}
      </PanelGenerico>
    </>
  );
};

export default FotosCheckList;
//#endregion

export interface IListLink {
  listUrlBase: string[];
}
